import { Flex } from '@mantine/core';
import { TbArrowsSort, TbSortAscending, TbSortDescending } from 'react-icons/tb';
import React from 'react';

interface SortConfig {
  key: string;
  direction: string;
}

interface SortButtonProps {
  columnName: string;
  sortConfig: SortConfig;
  setSortConfig: React.Dispatch<React.SetStateAction<SortConfig>>;
}

export function SortButton({ sortConfig, columnName, setSortConfig }: SortButtonProps) {
  const iconProps = {
    size: 16,
    style: { marginBottom: '2.5px' }
  };

  const handleSort = () => {
    setSortConfig(prev => {
      // Three-state cycle: Unsorted → Ascending → Descending → Unsorted
      if (prev.key === columnName) {
        if (prev.direction === columnName) return { key: columnName, direction: `-${columnName}` }; // ASC → DESC
        return { key: '', direction: '' }; // DESC → Clear (reset to unsorted)
      }
      return { key: columnName, direction: columnName }; // New column → ASC
    });
  };

  return (
    <Flex
      component="button"
      type="button"
      onClick={handleSort}
      align="center"
      style={{ cursor: 'pointer', background: 'transparent', border: 'none', padding: 0 }}
      data-testid={`sort-btn-${columnName}`}
      aria-label={`Sort by ${columnName}`}
    >
      {columnName !== sortConfig.key && <TbArrowsSort {...iconProps} color="#868E96" />}
      {columnName === sortConfig.key && sortConfig.direction === `-${columnName}` && (
        <TbSortDescending {...iconProps} color="#228BE6" />
      )}
      {columnName === sortConfig.key && sortConfig.direction === columnName && (
        <TbSortAscending {...iconProps} color="#228BE6" />
      )}
    </Flex>
  );
}
